<template>
  <div class="page-v4">
    <el-pagination
      @size-change="selPage"
      @current-change="pageSel"
      :current-page="current_page"
      :page-sizes="pageOptions"
      :page-size="per_page"
      :layout="layout"
      :total="totalRows"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "pagination",
  props: {
    totalRows: {
      type: Number,
      default: 1,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    pageOptions: {
      type: Array,
    },
    layout: {
      type: String,
      default: "total, prev, pager, next,sizes, jumper",
    },
  },
  data() {
    return {
      current_page: this.currentPage,
      per_page: this.perPage,
    };
  },
  watch: {
    currentPage(v) {
      this.current_page = v;
    },
    perPage(v) {
      this.per_page = v;
    },
  },
  methods: {
    //每页条数选择
    selPage(val) {
      this.$emit("perPage_now", this.per_page);
      this.per_page = val;
      let parameters = {
        page: this.current_page,
        pageSize: this.per_page,
      };
      this.$emit("initialize", parameters);
    },
    //点击分页
    pageSel() {
      this.current_page = arguments[0];
      this.$emit("pageNow", this.current_page);
      let page = arguments[0];
      let parameters = {
        page: page,
        pageSize: this.per_page,
      };
      this.$emit("initialize", parameters);
    },
  },
};
</script>

<style  lang="scss">
.page-v4-top {
  margin-top: 11px;
}
.page-v4 {
  text-align: right;
  padding-top: 5px;
  font-family: HarmonyOS-Regular;
  .el-icon-arrow-left {
    display: none !important;
  }
  .el-icon-arrow-right {
    display: none !important;
  }
  .btn-prev {
    width: 0;
    height: 0;
    border-width: 4px;
    border-style: solid;
    border-color: transparent #828ea3 transparent transparent;
    position: relative;
    top: 9px;
    right: 12px;
  }
  .btn-next {
    width: 0;
    height: 0;
    border-width: 4px;
    border-style: solid;
    border-color: transparent transparent transparent #828ea3;
    position: relative;
    top: 11px;
    left: 12px;
  }
  .el-pagination__total {
    color: #37435b;
    font-size: 14px;
  }
  .el-pager {
    li {
      min-width: 28px !important;
      color: #37435b;
      font-family: "HarmonyOS-Regular";
      font-style: normal;
      font-weight: 400;
    }
    .active {
      width: 28px !important;
      height: 28px !important;
      line-height: 28px !important;
      background: var(--theme-primary-hover-bg) !important;
      color: var(--theme-primary) !important;
      border-radius: var(--theme-radius-xs);
    }
  }
  .el-pagination__sizes {
    .el-input__inner {
      background: #f2f3f5;
      border: none;
    }
  }
  .el-pagination__jump {
    margin-left: 5px !important;
    .el-input__inner {
      border: none;
      background: #f2f3f5;
    }
  }
}
.el-select-dropdown__item.selected {
  color: var(--theme-primary) !important;
  background: #f7f8f9 !important;
  font-weight: normal !important;
}
.el-pagination .el-select .el-input {
  width: 90px !important;
}
.el-select-dropdown__item {
  margin-left: 10px;
  margin-right: 10px;
  line-height: 36px;
  height: 36px;
  font-family: "HarmonyOS-Regular" !important;
}
.el-pagination .el-input__suffix {
  right: 2px !important;
}
.el-pagination {
  .el-pagination__total {
    padding-right: 3px;
  }
}
.el-pagination .el-select .el-input .el-input__inner {
  color: #37435b !important;
  font-family: "HarmonyOS-Regular" !important;
}
.is-in-pagination {
  margin-left: 18px !important;
}
</style>
